var App = App || {};

App.MobileDropdown = (function ($) {
    "use strict";

    function init() {

        const header = $(".site-header");
        const triggers = $("[data-toggle=\"mobile-dropdown\"]");
        const dropdowns = $(".mobile-dropdown");
        const speed = 300;

        triggers.on("click", function () {
            const dropdownId = $(this).attr("aria-controls");
            const dropdown = dropdowns.filter(`#${dropdownId}`);
            if (dropdown.hasClass("show") == false) { Open(dropdown); }
            else { Close(dropdown); }
        });

        $(document).on("keydown", function (e) {
            if ($("body").hasClass("mobile-dropdown-engaged") && e.keyCode === 27) {
                Close(dropdowns.filter(".show"));
            }
        });

        $(document).on("enter-lg", function () {
            dropdowns.filter(".show").css({ top: header.outerHeight() })
            Close(dropdowns.filter(".show"));
        });

        $(document).on("enter-xs enter-sm", function () {
            dropdowns.filter(".show").css({ top: header.outerHeight() })
        });

        function Open(dropdown) {

            const eventShow = new Event("show:zag:mobiledropown");
            dropdown[0].dispatchEvent(eventShow);

            Close(dropdowns.filter(".show"));
            dropdown.addClass("show").css({ top: header.outerHeight() }).slideDown(speed, function () {
                const eventShown = new Event("shown:zag:mobiledropown");
                dropdown[0].dispatchEvent(eventShown);
            });
            triggers.filter(`[aria-controls=\"${dropdown.attr("id")}\"]`).addClass("active");
            $("body").addClass("mobile-dropdown-engaged");

        }

        function Close(dropdown) {

            if (dropdown.length > 0) {

                const eventHide = new Event("hide:zag:mobiledropown");
                dropdown[0].dispatchEvent(eventHide);

                dropdown.slideUp(speed, function () {

                    const eventHidden = new Event("hidden:zag:mobiledropown");
                    dropdown[0].dispatchEvent(eventHidden);

                    $(this).removeClass("show").removeAttr("style");
                    triggers.filter(`[aria-controls=\"${dropdown.attr("id")}\"]`).removeClass("active");
                    if (dropdowns.filter(".show").length == 0) {
                        $("body").removeClass("mobile-dropdown-engaged");
                    }
                });

            }
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.MobileDropdown.init();
});